module.exports = __webpack_public_path__ + "img/header_bloky_thumb.c7a2aa22.jpg";